module.exports = __webpack_public_path__ + "static/media/image9.1c44e2c1.jpeg";